import type { FlightDropdownOption } from 'components/Flights/types'
import RadioInput from 'LuxKit/Radio/RadioInput'
import Group from 'components/utils/Group'
import styled from 'styled-components'

const RadioContainer = styled(Group)`
  position: relative;
`

const RadioGroup = styled(Group)`
  &.flatten-items {
    display: contents;
  }
`

interface Props {
  options: Array<FlightDropdownOption>
  selectedOption?: FlightDropdownOption
  onOptionChange: (option: FlightDropdownOption) => void
  flattenItems?: boolean
}

function FareRadio(props: Props) {
  const { options, selectedOption, onOptionChange, flattenItems } = props

  return (
    <RadioGroup
      direction="horizontal"
      verticalAlign="center"
      gap={16}
      className={flattenItems ? 'flatten-items' : undefined}
    >
      {options.map((option) => (
        <RadioContainer direction="horizontal" key={option.value}>
          <RadioInput
            checked={selectedOption?.value === option.value}
            onClick={() => onOptionChange(option)}
            name="fareType"
            value={option.value}
            size="medium"
          >
            {option.label}
          </RadioInput>
        </RadioContainer>
      ))}
    </RadioGroup>
  )
}

export default FareRadio
